const STORAGE_KEY = 'compopo_watchlist';

function readWatchlist() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

function writeWatchlist(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function getWatchlist() {
  return readWatchlist();
}

export function isInWatchlist(productId) {
  return readWatchlist().some((item) => item.id === productId);
}

export function addToWatchlist(entry) {
  const list = readWatchlist();
  if (list.some((item) => item.id === entry.id)) {
    return list;
  }
  const next = [{ ...entry, addedAt: Date.now() }, ...list];
  writeWatchlist(next);
  return next;
}

export function removeFromWatchlist(productId) {
  const next = readWatchlist().filter((item) => item.id !== productId);
  writeWatchlist(next);
  return next;
}

export function toggleWatchlist(entry) {
  if (isInWatchlist(entry.id)) {
    return removeFromWatchlist(entry.id);
  }
  return addToWatchlist(entry);
}

export function buildWatchlistEntry(product, productKey, searchQuery) {
  const first = product.otherStores[0];
  return {
    id: productKey,
    title: first.title,
    imageUrl: first.image.imageUrl,
    itemType: product.itemType,
    stores: product.otherStores,
    searchQuery: searchQuery || '',
    lowestPrice: first.price.calcTotalPrice,
    currency: first.price.calcCurrency,
  };
}
